// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';

const emptyObj = {};
const emptyArray: [] = [];

export const selectKLMiscState = createSelector(
  (state: StateType) => state.kl.misc ?? emptyObj,
  (miscState) => miscState,
);

export const selectKLHomeVisitedIndex = createSelector(selectKLMiscState, (misc) => misc.homeVisitedIndex);

export const selectKLTmpNotifications = createSelector(
  selectKLMiscState,
  (misc) => misc.tmpNotifications ?? emptyArray,
);

export const selectKLHomeNavigationIsAllowed = createSelector(
  selectKLMiscState,
  (misc) => !!misc.homeNavigationIsAllowed,
);

export const selectKLOrientationPaginationIndex = createSelector(
  selectKLMiscState,
  (misc) => misc.orientationPaginationIndex ?? 0,
);
